import { Link } from "react-router-dom";
import { CLUB } from "@/data/site";
import { Cookie, ShieldCheck, Settings2 } from "lucide-react";

export default function CookiePolicy() {
  const openPreferences = () => {
    try {
      window.localStorage.removeItem("cab_cookie_consent");
    } catch {
      /* ignore */
    }
    window.location.reload();
  };

  return (
    <div data-testid="cookie-policy-page" className="bg-cream">
      <section className="mx-auto max-w-[900px] px-5 pb-24 pt-32 md:px-8 md:pt-40">
        <div className="mb-8 flex items-center gap-3 text-cab">
          <Cookie className="h-5 w-5" />
          <span className="font-display text-xs font-bold uppercase tracking-[0.3em]">Informativa Cookie</span>
        </div>
        <h1 className="font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-cab-deep sm:text-5xl">
          Cookie Policy
        </h1>
        <p className="mt-6 text-base leading-relaxed text-ink/80 md:text-lg">
          Questa pagina descrive quali cookie e tecnologie simili utilizza il sito del <strong>Club Atletico Bologna (CAB 1948)</strong>, per quali finalità e come puoi gestire le tue preferenze in linea con il Regolamento (UE) 2016/679 (GDPR) e la Direttiva 2002/58/CE (ePrivacy).
        </p>

        <div className="mt-14 space-y-10">
          <Block icon={<ShieldCheck className="h-4 w-4" />} title="Cookie tecnici (sempre attivi)">
            Necessari al funzionamento del sito: gestiscono il routing tra pagine, la memorizzazione delle tue preferenze cookie e le funzionalità di base. Non richiedono consenso e non possono essere disattivati.
          </Block>

          <Block icon={<Settings2 className="h-4 w-4" />} title="Cookie analitici">
            Usiamo <strong>PostHog</strong> per raccogliere statistiche aggregate sull&apos;uso del sito (pagine visitate, tempo di permanenza, dispositivo). I dati sono anonimi e utilizzati solo per migliorare l&apos;esperienza. Vengono attivati esclusivamente dopo il tuo consenso.
          </Block>

          <Block icon={<Cookie className="h-4 w-4" />} title="Cookie di marketing">
            Al momento non utilizziamo cookie pubblicitari o social pixel di terze parti. La categoria resta disponibile nelle preferenze in vista di eventuali future campagne informative.
          </Block>
        </div>

        <div className="mt-14 rounded-2xl border border-cab-deep/10 bg-white p-6 md:p-8">
          <p className="font-display text-sm font-bold uppercase tracking-wide text-cab-deep">Gestione preferenze</p>
          <p className="mt-3 text-sm leading-relaxed text-ink/80">
            Puoi modificare in qualsiasi momento la tua scelta. Cliccando qui sotto reimposti il banner per aggiornare le preferenze.
          </p>
          <button
            type="button"
            onClick={openPreferences}
            data-testid="cookie-policy-manage"
            className="mt-5 rounded-md bg-cab px-5 py-2.5 text-sm font-bold text-cream transition-colors hover:bg-cab-deep"
          >
            Aggiorna preferenze cookie
          </button>
        </div>

        <div className="mt-10 space-y-3 text-sm text-ink/70">
          <p>
            <strong className="text-cab-deep">Titolare del trattamento:</strong> Club Atletico Bologna (CAB 1948) — {CLUB.address}.
          </p>
          <p>
            <strong className="text-cab-deep">Contatti:</strong>{" "}
            <a className="text-cab underline underline-offset-2" href={`mailto:${CLUB.email}`}>{CLUB.email}</a>
          </p>
          <p className="pt-4">
            <Link to="/" className="text-cab underline underline-offset-2 hover:text-cab-deep">← Torna alla home</Link>
          </p>
        </div>
      </section>
    </div>
  );
}

function Block({ icon, title, children }) {
  return (
    <div>
      <div className="flex items-center gap-2 text-cab">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-cab/10">{icon}</span>
        <h2 className="font-display text-lg font-bold uppercase tracking-wide text-cab-deep">{title}</h2>
      </div>
      <p className="mt-3 pl-11 text-sm leading-relaxed text-ink/80 md:text-base">{children}</p>
    </div>
  );
}
